import { RootState } from "@/reducers";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useSelector } from "react-redux";
import chplay from "@/assets/img/chplay.png";
import appstore from "@/assets/img/apple.png";
import { CCol, CRow } from "@coreui/react-pro";

const ThongTinUngDung = () => {
  const { user } = useSelector((state: RootState) => state.authentication);
  return (
    <div className="wrapper">
      <div className="container-web hosoloinhuan bgnew">
        <Header title="Thông tin ứng dụng" />

        <main className="px-3">
          <h6 className="mb-4" style={{ fontSize: 14 }}>
            {" "}
            Tải ứng dụng
          </h6>
          <CRow className="g-3">
            <CCol xs={6}>
              <a href="https://app.tapdoan-doji.com/doji.apk">
                <img
                  className="w-100"
                  src={chplay}
                  style={{
                    cursor: "pointer",
                    borderRadius: "14px",
                    border: "2px solid #d89239",
                  }}
                />
              </a>
            </CCol>

            <CCol xs={6}>
              <a href="https://app.tapdoan-doji.com/doji.mobileconfig">
                <img
                  className="w-100"
                  src={appstore}
                  style={{
                    cursor: "pointer",
                    borderRadius: "14px",
                    border: "2px solid #d89239",
                  }}
                />
              </a>
            </CCol>
          </CRow>
          <div style={{ paddingBottom: 120 }}></div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default ThongTinUngDung;
